var chunkMapping = {
	"0": [
		4654
	],
	"3": [
		4055,
		4588
	],
	"78": [
		5090
	],
	"163": [
		5177
	],
	"164": [
		5178
	],
	"167": [
		5181
	],
	"168": [
		5182
	],
	"169": [
		5183
	],
	"170": [
		5184
	],
	"171": [
		5185
	],
	"172": [
		5186
	],
	"173": [
		5187
	],
	"174": [
		5188
	],
	"175": [
		5189
	],
	"176": [
		5190
	],
	"177": [
		5191
	],
	"178": [
		5192
	],
	"179": [
		5193
	],
	"180": [
		5194
	],
	"181": [
		5195
	],
	"182": [
		5196
	],
	"183": [
		5197
	],
	"184": [
		5198
	],
	"185": [
		5199
	],
	"186": [
		5200
	]
};
var idToExternalAndNameMapping = {
	"4055": [
		"default",
		"./nuorder-components",
		3672
	],
	"4588": [
		"default",
		"./helios-components",
		3672
	],
	"4654": [
		"default",
		"./Containers",
		3582
	],
	"5090": [
		"default",
		"./OrderlessInvoices",
		3582
	],
	"5177": [
		"default",
		"./AsyncEventTracker",
		3582
	],
	"5178": [
		"default",
		"./HostWrapper",
		3582
	],
	"5181": [
		"default",
		"./CheckoutV3",
		3582
	],
	"5182": [
		"default",
		"./CheckoutConfirmation",
		3582
	],
	"5183": [
		"default",
		"./ContactCreditCards",
		3582
	],
	"5184": [
		"default",
		"./AuditDialog",
		3582
	],
	"5185": [
		"default",
		"./InvoiceBlocksOrderDialog",
		3582
	],
	"5186": [
		"default",
		"./InvoiceDialog",
		3582
	],
	"5187": [
		"default",
		"./PaymentDueModal",
		3582
	],
	"5188": [
		"default",
		"./PaymentModal",
		3582
	],
	"5189": [
		"default",
		"./PaymentHistory",
		3582
	],
	"5190": [
		"default",
		"./PaymentConfigurations",
		3582
	],
	"5191": [
		"default",
		"./PaymentPreferences",
		3582
	],
	"5192": [
		"default",
		"./ManagePaymentProcessing",
		3582
	],
	"5193": [
		"default",
		"./MobilePaymentsWrapper",
		3582
	],
	"5194": [
		"default",
		"./PayPage",
		3582
	],
	"5195": [
		"default",
		"./Challenge",
		3582
	],
	"5196": [
		"default",
		"./ManagePaymentMethods",
		3582
	],
	"5197": [
		"default",
		"./LightspeedReports",
		3582
	],
	"5198": [
		"default",
		"./ActivateLightspeedPayments",
		3582
	],
	"5199": [
		"default",
		"./MarketingLandingPage",
		3582
	],
	"5200": [
		"default",
		"./ShippingPromotionsListContainer",
		3582
	]
};
var idToRemoteMap = {
	"4055": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3672
		}
	],
	"4588": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3672
		}
	],
	"4654": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5090": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5177": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5178": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5181": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5182": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5183": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5184": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5185": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5186": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5187": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5188": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5189": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5190": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5191": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5192": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5193": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5194": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5195": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5196": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5197": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5198": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5199": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5200": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}